import {useEffect, useRef} from 'react'

const usePrevious = <V = any>(value: V): V | undefined => {
  const prevRef = useRef<V>()

  useEffect(() => {
    if (prevRef) {
      prevRef.current = value
    }
  }, [value])

  return prevRef?.current
}

export default usePrevious
